// src/pages/ProductsPage.jsx

import { useEffect, useState } from "react";
import API from "../services/api";
import { Link } from "react-router-dom";

const ProductsPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await API.get("/products/");
        setProducts(res.data);
      } catch (err) {
        console.error("Error loading products:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return <h2>Loading products... ⏳</h2>;
  }

  return (
    <div style={{ padding: 30 }}>
      <h1>🛍️ All Products</h1>

      {products.length === 0 ? (
        <p>No products found.</p>
      ) : (
        products.map((p) => (
          <div
            key={p.id}
            style={{
              border: "1px solid #ddd",
              padding: 15,
              marginBottom: 10,
              borderRadius: 8,
            }}
          >
            <h3>{p.title}</h3>
            <p>{p.description}</p>
            <b>₦{p.price}</b>

            

            <Link to={`/product/${p.id}`}>
              <button style={{ marginTop: 10, marginLeft: 20 }}>
                View Product
              </button>
            </Link>
          </div>
        ))
      )}
    </div>
  );
};

export default ProductsPage;